import React, { createContext, useState, useContext } from "react";

export const AssetFormTypeContext = createContext(null);

const AssetFormTypeProvider = ({ children }) => {
  const [type, setType] = useState("image");
  return (
    <AssetFormTypeContext.Provider
      value={{
        type,
        setType,
      }}
    >
      {children}
    </AssetFormTypeContext.Provider>
  );
};

export const useAssetFormTypeContext = () => {
  const context = useContext(AssetFormTypeContext);
  if (context === undefined) {
    throw new Error("useAssetFormTypeContext must be used within a AssetFormTypeProvider");
  }
  return context;
};

export default AssetFormTypeProvider;
